import React from 'react';

// lucide-react doesn't ship WhatsApp, Snapchat, or the current X logo (its
// "Twitter" export is the retired bird mark), so these are hand-drawn to
// match the same 24x24 sizing convention as the rest of the icon set.

export function XIcon({ size = 20, ...props }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M18.9 2h3.3l-7.2 8.2L23.5 22h-6.6l-5.2-6.8L5.7 22H2.4l7.7-8.8L2 2h6.8l4.7 6.2zm-1.2 18h1.8L7.4 3.9H5.5z"/>
    </svg>
  );
}

export function WhatsAppIcon({ size = 20, ...props }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M17.47 14.38c-.29-.15-1.71-.84-1.97-.94-.27-.1-.46-.15-.66.15-.19.29-.75.94-.92 1.13-.17.2-.34.22-.63.08-.29-.15-1.22-.45-2.33-1.44-.86-.77-1.44-1.72-1.61-2.01-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.19-.29.29-.49.1-.19.05-.36-.02-.51-.08-.15-.66-1.58-.9-2.17-.24-.57-.48-.49-.66-.5-.17-.01-.36-.01-.56-.01-.19 0-.51.07-.78.36-.27.29-1.02 1-1.02 2.43 0 1.43 1.04 2.82 1.19 3.01.15.19 2.05 3.13 4.96 4.39.69.3 1.23.48 1.65.61.69.22 1.32.19 1.82.11.55-.08 1.71-.7 1.95-1.37.24-.68.24-1.26.17-1.38-.07-.12-.26-.19-.55-.34z"/>
      <path d="M12.02 2C6.5 2 2.03 6.47 2.03 12c0 1.77.46 3.45 1.28 4.91L2 22l5.24-1.37A9.94 9.94 0 0 0 12.02 22C17.55 22 22 17.53 22 12S17.55 2 12.02 2zm0 18.15c-1.6 0-3.15-.43-4.5-1.24l-.32-.19-3.11.82.83-3.03-.21-.31A8.13 8.13 0 0 1 3.85 12c0-4.5 3.66-8.15 8.17-8.15 4.51 0 8.17 3.65 8.17 8.15 0 4.5-3.66 8.15-8.17 8.15z"/>
    </svg>
  );
}

export function SnapchatIcon({ size = 20, ...props }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 3c2.6 0 4.4 1.94 4.55 4.36l.02.36c.02.5.03 1.15.01 1.68l.28.05c.4.08.79-.14 1-.48a.9.9 0 0 1 .77-.42c.55 0 1.03.4 1.03.93 0 .43-.32.72-.66.94-.13.09-.42.24-.55.33-.2.14-.24.36-.13.58.32.63 1.06 1.62 2.4 2.06.2.07.32.27.28.48-.09.5-.9.86-2.31 1.04-.06.16-.13.44-.19.66-.06.24-.27.4-.53.4h-.02c-.34-.01-.7-.06-1.09-.06-.55 0-.95.13-1.35.42-.62.44-1.29 1.06-2.51 1.06s-1.89-.62-2.51-1.06c-.4-.29-.8-.42-1.35-.42-.39 0-.75.05-1.09.06h-.02c-.26 0-.47-.16-.53-.4-.06-.22-.13-.5-.19-.66-1.41-.18-2.22-.54-2.31-1.04a.53.53 0 0 1 .28-.48c1.34-.44 2.08-1.43 2.4-2.06.11-.22.07-.44-.13-.58-.13-.09-.42-.24-.55-.33-.34-.22-.66-.51-.66-.94 0-.53.48-.93 1.03-.93.32 0 .59.16.77.42.21.34.6.56 1 .48l.28-.05c-.02-.53-.01-1.18.01-1.68l.02-.36C7.6 4.94 9.4 3 12 3z"/>
    </svg>
  );
}
